import Background from 'assets/images/icons/ActorDiscIcon.svg'
import VaCustomAvatar from 'assets/images/icons/VaCustomAvatar.svg?react'
import {
  BsFillFileEarmarkArrowUpFill as FileUploadIcon,
  BsPerson as HumanAgentIcon,
  BsGear as RobotIcon,
} from 'react-icons/bs'
import { FaFilePdf } from 'react-icons/fa'
import styled from 'styled-components'

export enum ActorIconTypeEnum {
  businessLogic,
  fileUpload,
  humanAgent,
  unknown,
  AIAgent,
  eobFax,
}

const classField = 'field'
const classIcon = 'icon'
const classCenterer = 'center'
const FileUpload = (
  <FileUploadIcon
    style={{
      width: '20px',
      height: '20px',
      left: '23%',
      top: '22%',
      position: 'absolute',
      filter: 'invert(50%) sepia(5%) saturate(366%) hue-rotate(169deg) brightness(90%) contrast(89%)',
    }}
  />
)
const AIAgent = (
  <VaCustomAvatar
    style={{
      width: '20px',
      height: '20px',
      left: '23%',
      top: '22%',
      position: 'absolute',
      filter: 'invert(50%) sepia(5%) saturate(366%) hue-rotate(169deg) brightness(90%) contrast(89%)',
    }}
  />
)
const HumanAgent = <HumanAgentIcon className={classIcon} />
const Robot = <RobotIcon className={classIcon} />
const EOBFax = <FaFilePdf className={classIcon} />

const ActorIcons: Map<ActorIconTypeEnum, JSX.Element> = new Map<ActorIconTypeEnum, JSX.Element>([
  [ActorIconTypeEnum.businessLogic, Robot],
  [ActorIconTypeEnum.fileUpload, FileUpload],
  [ActorIconTypeEnum.humanAgent, HumanAgent],
  [ActorIconTypeEnum.AIAgent, AIAgent],
  [ActorIconTypeEnum.eobFax, EOBFax],
])
export const ClaimHistoryActorIcon = ({
  actorIconType,
  className,
}: {
  actorIconType: ActorIconTypeEnum
  className?: string
}) => {
  return (
    <Div className={className}>
      <div className={classCenterer}>
        <img src={Background} alt="Background" className={classField} />
      </div>
      <div className={classCenterer}>{ActorIcons.has(actorIconType) && ActorIcons.get(actorIconType)}</div>
    </Div>
  )
}

const Div = styled.div`
  margin: 0;
  width: 35px;
  height: 35px;
  position: relative;
  .${classField} {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-order: -1;
  }
  .${classIcon} {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 50%;
    width: 50%;
    transform: translate(-50%, -50%);
  }
  .${classCenterer} {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    color: #72767a;
  }
`
